import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const filterVariants = cva('flex items-end flex-wrap justify-between gap-6 mb-6 w-full', {
  variants: {
    variant: {
      default: 'border-b border-solid border-primary-lightest pb-5',
      plain: ''
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});

const Filter = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-filter', filterVariants({ variant }), className)}
    {...props}
  />
));
Filter.displayName = 'Filter';

const FilterContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex max-w-full flex-wrap items-end gap-x-5 gap-y-4', className)}
    {...props}
  />
));
FilterContent.displayName = 'FilterContent';

const FilterActions = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-wrap items-end gap-5', className)}
    {...props}
  />
));
FilterActions.displayName = 'FilterActions';

const FilterRow = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-filter-row', 'flex w-full max-w-full flex-col gap-1.5 md:w-52', className)}
    {...props}
  />
));
FilterRow.displayName = 'FilterRow';

const FilterTitle = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-filter-title', 'mb-0 truncate text-base font-extrabold text-primary-dark', className)}
    {...props}
  />
));
FilterTitle.displayName = 'FilterTitle';

const FilterHat = React.forwardRef(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn('c-filter-hat', 'mb-0 w-full text-xs font-light text-neutral', className)}
    {...props}
  />
));
FilterHat.displayName = 'FilterHat';

export { Filter, FilterContent, FilterActions, FilterRow, FilterTitle, FilterHat };
